import { createI18nInstance, createI18nUtils } from '@opendoor/shared-fe/i18n';

import { DEPLOY_ENV } from 'components/globals';

import Resources from '../__generated__/i18n-resources';
import translations from '../locales/en.json';
import translationsEs from '../locales/es.json';

const DEBUG_i18n = DEPLOY_ENV !== 'production';

export const i18n = createI18nInstance(translations, translationsEs, DEBUG_i18n);

const defaultUtils = createI18nUtils<Resources>(i18n, DEBUG_i18n);
export const I18nHighlightProvider = defaultUtils.I18nHighlightProvider;
export const useT = defaultUtils.useT;
export const T = defaultUtils.T;
export type TFunction = ReturnType<typeof defaultUtils.useT>['t'];
